import React from "react";
import Classes from "./styles/style.module.css";
import { Link } from "react-router-dom";
import { MdInstallMobile } from "react-icons/md";
import useHomeAddress from "../../Hooks/getHomeAddress";
import ProfileIcon from "../../images/icons/profileBlueIcon.svg";
import HomePrimaryColor from "../../images/icons/home-PrimaryColor.svg";
import InormationIcon from "../../images/icons/informationPrimaryColor.svg";
import LogoutIcon from "../../images/icons/logout.svg";
import LoginIcon from "../../images/icons/login.svg";

const generateIcon = (text) => {
  switch (text) {
    case "کاربر":
      return <img src={ProfileIcon} alt="profile" />;
    case "خانه":
      return <img src={HomePrimaryColor} alt="home" />;
    case "خروج از حساب کاربری":
      return <img src={LogoutIcon} alt="logout" />;
    case "ورود به حساب کاربری":
      return <img src={LoginIcon} alt="login" />;
    case "پشتیبان امور فرهنگی":
      return <img src={InormationIcon} alt="support" />;
    case "دانلود به‌روزرسانی":
      return <MdInstallMobile size={25} />;
    default:
      return <img src={LogoutIcon} alt="logout" />;
  }
};

const NavElement = ({
  isLink,
  text,
  link,
  clickHandler,
  blankLink,
  active,
}) => {
  const { homeAddress } = useHomeAddress();

  if (isLink && !blankLink) {
    return (
      <div className={`${Classes.sideItem}`}>
        <Link to={link} replace={link === homeAddress}>
          <div className="d-flex align-items-center">
            {generateIcon(text)}
            <p>{text}</p>
          </div>
        </Link>
      </div>
    );
  } else {
    return (
      <div
        className={`${Classes.sideItem} ${active ? Classes.acitveItem : null}`}
        onClick={clickHandler}
      >
        <div className="d-flex align-items-center">
          {generateIcon(text)}
          <p style={{ color: text === "خروج از حساب کاربری" ? "#F00" : "" }}>
            {text}
          </p>
        </div>
      </div>
    );
  }
};

export default NavElement;
